// @mui
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
//
import BlogCommentItem from './blog-comment-item';
// types
type IBlogCommentsModel = {
  id: string;
  blog_id: string;
  user_id: string;
  user_name: string;
  comment_text: string;
  date: Date | string;
};

// ----------------------------------------------------------------------

type Props = {
  comments: IBlogCommentsModel[];
};

export default function BlogCommentList({ comments }: Props) {
  return (
    <>
      <>
        {comments.map((comment) => {
          const { id, user_name, comment_text, date } = comment;

          return (
            <Box key={id}>
              <BlogCommentItem
                name={user_name}
                message={comment_text}
                postedAt={new Date(date)}
                avatarUrl={`/assets/images/avatar/avatar_${Math.floor(Math.random() * 24) + 1}.jpg`}
              />
            </Box>
          );
        })}
      </>

      <Pagination count={8} sx={{ my: 5, mx: 'auto' }} />
    </>
  );
}
